import moment from 'moment';
import type Moment from 'moment';

import {isToday, isTomorrow} from 'nutshell-core/date-time';

/**
 * Helper function to get both the participants to display in an activity item
 * as well as the participant to shove into the avatar
 * @param  {array} participants Array of participants
 * @param  {string} userId      User id of the current logged in user
 * @return {object}             Object of both showParticipants and avatarParticipants
 */
export function getParticipantsDisplay(participants: any[], userId: string) {
    // If all we got is our one participant, show it and use
    // it as the avatar participant as well
    if (participants.length === 1) {
        return {
            shownParticipants: participants,
            avatarParticipant: participants[0],
        };
    }

    // Otherwise, always filter out the current user
    const shownParticipants = participants.filter((participant) => {
        return participant.id !== userId;
    });

    // Ideally, we want to show a named, non-user to display in the avatar
    const nonUserParticipants = shownParticipants.filter((participant) => {
        return participant.name && participant.type !== 'users';
    });

    const userParticipants = shownParticipants.filter((participant) => {
        return participant.name && participant.type === 'users';
    });

    const orderedParticipants = nonUserParticipants.concat(userParticipants);

    // If we don't have a "desired" avatar participant, just show the first
    // shown participant. This happens when all of our participants are either
    // users or have no name.
    return {
        shownParticipants: orderedParticipants,
        avatarParticipant: orderedParticipants[0],
    };
}

// @ts-expect-error
export function formatDateForOverdueActivity(date: Moment, now: Moment = moment()) {
    let formattedDate = date.format('MMM Do');

    if (isToday(date, now)) {
        formattedDate = 'Today';
    } else if (isTomorrow(date, now)) {
        formattedDate = 'Yesterday';
    } else if (!date.isSame(now, 'year')) {
        formattedDate = date.format('MMM Do, YYYY');
    }

    return formattedDate;
}
